import React from 'react';
import { FaGithub, FaLinkedin, FaDownload } from 'react-icons/fa';

const Navbar = () => {
  return (
    <nav className="fixed top-0 w-full bg-gradient-to-r from-gray-900 via-blue-900 to-gray-900 bg-opacity-90 backdrop-blur-lg z-50 shadow-xl">
      <div className="max-w-7xl mx-auto px-4 py-4 flex flex-wrap justify-between items-center">
        {/* Logo */}
        <div className="text-3xl font-extrabold tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
          Teerth Pandya
        </div>

        {/* Nav links */}
        <div className="flex flex-wrap items-center space-x-6 mt-2 md:mt-0">
          {['About', 'Skills', 'Experience', 'Projects', 'Education', 'Contact'].map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="text-base font-medium hover:text-blue-400 transition-all duration-300 relative group"
            >
              {item}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-400 group-hover:w-full transition-all duration-300"></span>
            </a>
          ))}

         
          <a
            href="/Teerth_new_resume.pdf" 
            download
            className="text-base font-medium flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition duration-300"
          >
            <FaDownload className="text-sm" /> Resume
          </a>

          {/* Social Icons */}
          <div className="flex items-center space-x-4 ml-2">
            <a href="https://github.com/Pandyateerth" target="_blank" rel="noopener noreferrer">
              <FaGithub className="text-2xl hover:text-blue-400 hover:scale-110 transition-all duration-300" />
            </a>
            <a href="https://linkedin.com/in/teerth-pandya" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="text-2xl hover:text-blue-400 hover:scale-110 transition-all duration-300" />
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
